import { render, staticRenderFns } from "./AddSubject.vue?vue&type=template&id=4ac65e83&scoped=true&"
import script from "./AddSubject.vue?vue&type=script&lang=js&"
export * from "./AddSubject.vue?vue&type=script&lang=js&"
import style0 from "./AddSubject.vue?vue&type=style&index=0&id=4ac65e83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac65e83",
  null
  
)

export default component.exports